<template>
  <div class="calico-close-chat-page">
    <CalicoCloseChat text="View Profile" />
  </div>
</template>

<script>
  import CalicoCloseChat from '@/components/calico/closeChat/index.vue';

  export default {
    name: 'CalicoCloseChatPage',
    components: {
      CalicoCloseChat,
    }
  };
</script>

<style lang="scss">
  .calico-close-chat-page {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>